export var CalloutPlacement;
(function (CalloutPlacement) {
    CalloutPlacement["TOP"] = "top";
    CalloutPlacement["BOTTOM"] = "bottom";
    CalloutPlacement["LEFT"] = "start";
    CalloutPlacement["RIGHT"] = "end";
    CalloutPlacement["BOTTOM_LEFT"] = "bottom-left";
    CalloutPlacement["BOTTOM_RIGHT"] = "bottom-right";
    CalloutPlacement["RIGHT_BOTTOM"] = "end-bottom";
    CalloutPlacement["RIGHT_TOP"] = "end-top";
})(CalloutPlacement || (CalloutPlacement = {}));
